
var id = "campaign";
var markup = "<symbol viewBox=\"0 0 22 23\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"campaign\">\n    <title>活动</title>\n    <defs>\n        <path d=\"M15.5833333,2.75 L6.41666667,2.75 C5.40833333,2.75 4.58333333,3.575 4.58333333,4.58333333 L4.58333333,19.25 L11,16.5 L17.4166667,19.25 L17.4166667,4.58333333 C17.4166667,3.575 16.5916667,2.75 15.5833333,2.75 Z M15.5833333,16.5 L11,14.5016667 L6.41666667,16.5 L6.41666667,4.58333333 L15.5833333,4.58333333 L15.5833333,16.5 Z\" id=\"campaign_path-1\" />\n    </defs>\n    <g id=\"campaign_预约活动\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <g id=\"campaign_营销活动-预约活动-活动分析\" transform=\"translate(-312.000000, -273.000000)\">\n            <g id=\"campaign_区块-查询\" transform=\"translate(280.000000, 248.000000)\">\n                <g id=\"campaign_编组\" transform=\"translate(32.000000, 24.000000)\">\n                    <g id=\"campaign_icon/notification/event_note_24px\" transform=\"translate(0.000000, 1.500000)\">\n                        <mask id=\"campaign_mask-2\" fill=\"white\">\n                            <use xlink:href=\"#campaign_path-1\" />\n                        </mask>\n                        <use id=\"campaign_icon/action/bookmark_border_24px\" fill-opacity=\"0.87\" fill=\"#000000\" xlink:href=\"#campaign_path-1\" />\n                    </g>\n                </g>\n            </g>\n        </g>\n    </g>\n</symbol>";
(function injectSprite() {
  if (typeof document === 'undefined') return;
  var SPRITE_ID = '__UMI_SVG_SPRITE__';
  function ensure() {
    var root = document.getElementById(SPRITE_ID);
    if (!root) {
      root = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      root.setAttribute('id', SPRITE_ID);
      root.setAttribute('aria-hidden', 'true');
      root.setAttribute('style', 'position:absolute;width:0;height:0;overflow:hidden');
      var parent = document.body || document.documentElement;
      parent.insertBefore(root, parent.firstChild);
    }
    if (document.getElementById(id)) return;
    try {
      root.insertAdjacentHTML('beforeend', markup);
      return;
    } catch (e) {}
    try {
      var doc = new DOMParser().parseFromString(
        '<svg xmlns="http://www.w3.org/2000/svg">' + markup + '</svg>',
        'image/svg+xml'
      );
      var node = doc.querySelector('symbol');
      if (node) root.appendChild(document.importNode(node, true));
    } catch (e2) {}
  }
  if (document.body || document.documentElement) ensure();
  else document.addEventListener('DOMContentLoaded', ensure);
})();
module.exports = id;
module.exports.default = id;
module.exports.id = id;
